import React from "react";
import { graphql, Link } from "gatsby";
import Layout from "../components/layout";

export default function Blogs ({data}) {

    const blogs = data.allMarkdownRemark.edges.map((edge, index) => {
        return (
            <article className="blog-listing" key={index}>
                <h2>{edge.node.frontmatter.title}</h2>
                <p className="blog-listing__published-date">{edge.node.frontmatter.date}</p>
                <p>{edge.node.excerpt}</p>
                <Link to={'/blog/' + edge.node.frontmatter.slug}>Read more...</Link>
            </article>
        );
    });

    return (
        <Layout>
            <div className="blogs-page">
                <h1>Blogs</h1>
                <div>
                    {blogs}
                </div>
            </div>
        </Layout>
    )
}

export const pageQuery = graphql`
    query {
        allMarkdownRemark(filter: {frontmatter: {type: {eq: "blog"}}}, sort: {fields: frontmatter___date, order: DESC}) {
            edges {
                node {
                    excerpt(pruneLength: 200)
                    frontmatter {
                        date(formatString: "DD MMMM YYYY")
                        slug
                        title
                    }
                }
            }
        }
    }
`;